export default "__VITE_ASSET__d1a41ea5__"